<div class="admindashboard container">
  <div class="row mt-3">
    <div class="col-7">
      <div class="row">
        <div class="col-12">
          <h2>Disponibilités</h2>
          <div class="papercard">
            <div class="admindashboard__stat">
              <div class="admindashboard__stat__item">
                {{ this.defaultAvailable + this.available - this.unavailable }}
                <span>Disponibles</span>
              </div>
              <div class="admindashboard__stat__item">
                {{ this.onSite }}
                <span>Au studio</span>
              </div>
              <div class="admindashboard__stat__item">
                {{ this.leave }}
                <span>Absent·e·s</span>
              </div>
              <div class="admindashboard__stat__item">
                {{ this.sickLeave }}
                <span>Malades</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <h2>État des séances vocales</h2>
          <div class="papercard">
            <table class="table table-striped">
              <thead>
              <tr>
                <th>Langue</th>
                <th>En attente</th>
                <th>A masteriser</th>
                <th>A attribuer</th>
                <th>En-cours de découpe</th>
              </tr>
              </thead>
              <tbody>
              @for (item of this.seancesPV | keyvalue; track item) {
<tr>
                <td>{{ $any(item.value).Langue }}</td>
                <td>{{ $any(item.value).EnAttente }}</td>
                <td>{{ $any(item.value).ARemasteriser }}</td>
                <td>{{ $any(item.value).AAttribuer }}</td>
                <td>{{ $any(item.value).EnCoursDecoupe }}</td>
              </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <h2>Prises voix</h2>
          <div class="papercard">
            @if (pvStats) {
<div>
              @for (catPvStat of pvStats | keyvalue; track catPvStat) {
<div>
                @if ($any(catPvStat.value)?.PV) {
<table class="table table-striped caption-top">
                  <caption><u><b>{{ catPvStat.key }}</b></u></caption>
                  <thead>
                  <tr>
                    <th>Langue</th>
                    <th>Féminin</th>
                    <th>Masculin</th>
                  </tr>
                  </thead>
                  <tbody>
                  @for (item of $any(catPvStat.value).PV | keyvalue; track item) {
<tr>
                    <td>{{ $any(item.value).Langue }}</td>
                    <td>{{ $any(item.value)['Féminin'] }}</td>
                    <td>{{ $any(item.value).Masculin }}</td>
                  </tr>
}
                  </tbody>
                </table>
}
              </div>
}
            </div>
}
          </div>
        </div>
      </div>

    </div>
    <div class="col-5">
      <div class="row">
        <div class="col-12">
          <h2>Au studio aujourd'hui</h2>
          <div class="papercard">
            @if (this.onSiteDetails.length > 0) {
<ul class="admindashboard__onsitetoday">
              @for (spk of this.onSiteDetails; track spk) {
<li>
                {{ spk.speaker }}
                <span class="badge text-bg-info">
                  {{ format(parseISO(spk.hour), "HH'h'mm") }}
                </span>
              </li>
}
            </ul>
} @else {

              <div class="text-center fst-italic text-secondary">Personne ne sera présent au studio aujourd'hui</div>
            
}
            
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <h2>Traductions</h2>
          <div class="papercard">
            @if (pvStats) {
<div>
              @for (catPvStatTRAD of pvStats | keyvalue; track catPvStatTRAD) {
<div>
                @if ($any(catPvStatTRAD.value)?.TRAD && !Array.isArray($any(catPvStatTRAD.value).TRAD)) {
<table class="table table-striped caption-top">
                  <caption><u><b>{{ catPvStatTRAD.key }}</b></u></caption>
                  <thead>
                  <tr>
                    <th>Langue</th>
                    <th>Nombre</th>
                  </tr>
                  </thead>
                  <tbody>
                  @for (item of $any(catPvStatTRAD.value).TRAD | keyvalue; track item) {
<tr>
                    <td>{{ $any(item.value).Langue }}</td>
                    <td>{{ $any(item.value).Nombre }}</td>
                  </tr>
}
                  </tbody>
                </table>
}
              </div>
}
            </div>
}
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <h2>État des séances de traduction</h2>
          <div class="papercard">
            <table class="table table-striped">
              <thead>
              <tr>
                <th>Langue</th>
                <th>En attente</th>
              </tr>
              </thead>
              <tbody>
              @for (item of this.seancesTranslation | keyvalue; track item) {
<tr>
                <td>{{ $any(item.value).Langue }}</td>
                <td>{{ $any(item.value).EnAttente }}</td>
              </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
